<micro-lookup domain="access" obj="saCabinets" url="/access/saCabinets" [key]="saCabinetId" [link]="link"></micro-lookup>
